export default __webpack_public_path__ + "static/media/personagens.1eb9e8f7.svg";